export default __webpack_public_path__ + "static/media/whiterightMore.af228250.svg";